import { type CoreMessageType } from "@sendbird/uikit-react/types/utils";

export enum CustomMessageTypes {
  SHIFT_REVIEW = "SHIFT_REVIEW",
  FCM_REQUEST = "FCM_REQUEST",
  FCM_APPROVAL = "FCM_APPROVAL",
  FCM_REJECT = "FCM_REJECT",
  INPUT_ETA = "INPUT_ETA",
  SHIFT_INVITE_REQUEST = "SHIFT_INVITE_REQUEST",
  SHIFT_INVITE_RESPONSE = "SHIFT_INVITE_RESPONSE",
  VISIT_INVITE_REQUEST = "VISIT_INVITE_REQUEST",
  PLACEMENT_APPLICATION = "PLACEMENT_APPLICATION",
  PLACEMENT_APPLICATION_SUGGEST_INTERVIEW = "PLACEMENT_APPLICATION_SUGGEST_INTERVIEW",
  PLACEMENT_APPLICATION_CHAT_INTERVIEW_SCHEDULED = "PLACEMENT_APPLICATION_CHAT_INTERVIEW_SCHEDULED",
  PLACEMENT_APPLICATION_AUTO_INTERVIEW_INVITE = "PLACEMENT_APPLICATION_AUTO_INTERVIEW_INVITE",
  SHIFT_TIME_PROPOSAL_CREATED = "SHIFT_TIME_PROPOSAL_CREATED",
  SHIFT_TIME_PROPOSAL_UPDATED = "SHIFT_TIME_PROPOSAL_UPDATED",
  SHIFT_TIME_PROPOSAL_REPLIED = "SHIFT_TIME_PROPOSAL_REPLIED",
  WORKER_CREDENTIAL_SHARED = "WORKER_CREDENTIAL_SHARED",
  PLACEMENT_APPLICATION_REJECTION_BY_WORKPLACE = "PLACEMENT_APPLICATION_REJECTION_BY_WORKPLACE",
  INTERVIEW_WORKER_CANCELLATION = "INTERVIEW_WORKER_CANCELLATION",
  SHIFT_ACTION = "SHIFT_ACTION",
  SHIFT_BOOKED = "SHIFT_BOOKED",
}

export interface ShiftInviteMessageProps {
  message: CoreMessageType;
}

export interface ShiftTimeProposalMessageProps {
  message: CoreMessageType;
}

export interface ShiftTimeProposalResponseMessageProps {
  message: CoreMessageType;
}

export interface BookedShiftMessageProps {
  message: CoreMessageType;
}

export interface WorkerCredentialSharedMessageProps {
  message: CoreMessageType;
  workplaceId: string;
  workerId: string;
}

export interface VisitInviteMessageProps {
  message: CoreMessageType;
  workplaceId: string;
}
